import BodyTypeEnum from "enum/body-type";

const bodyInputType = [
	{ label: "Text", value: BodyTypeEnum.Text },
	{ label: "Image", value: BodyTypeEnum.Image },
];

export default bodyInputType;
